export const selectProductsHistory = (state) => state.productsReducer.history;
